import { createActions, createReducer } from 'reduxsauce'

import DetalhesRecursoRecebidoService from '../../servicos/DetalhesRecursoRecebidoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaCronogramaDesembolsoRecursoRecebidoInicio: [],
    buscaCronogramaDesembolsoRecursoRecebidoSucesso: ['cronogramaDesembolsoRecursoRecebido'],
    buscaCronogramaDesembolsoRecursoRecebidoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaCronogramaDesembolsoRecursoRecebido = filtro => {
    return dispatch => {
        dispatch(Creators.buscaCronogramaDesembolsoRecursoRecebidoInicio())
        let serv = new DetalhesRecursoRecebidoService()
        return serv
            .consultarCronogramaDesembolso(filtro)
            .then(response => dispatch(Creators.buscaCronogramaDesembolsoRecursoRecebidoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaCronogramaDesembolsoRecursoRecebidoErro(error)))
    }
}

const buscaCronogramaDesembolsoRecursoRecebidoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaCronogramaDesembolsoRecursoRecebidoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaCronogramaDesembolsoRecursoRecebidoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.cronogramaDesembolsoRecursoRecebido, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CRONOGRAMA_DESEMBOLSO_RECURSO_RECEBIDO_INICIO]: buscaCronogramaDesembolsoRecursoRecebidoInicio,
    [Types.BUSCA_CRONOGRAMA_DESEMBOLSO_RECURSO_RECEBIDO_ERRO]: buscaCronogramaDesembolsoRecursoRecebidoErro,
    [Types.BUSCA_CRONOGRAMA_DESEMBOLSO_RECURSO_RECEBIDO_SUCESSO]: buscaCronogramaDesembolsoRecursoRecebidoSucesso,
})
